import React from 'react'
import Checkbox from 'antd/lib/checkbox'

class FieldCheckbox extends React.Component {
  handleChange = val => {
    this.props.onChange(val[0] ? true : false)
  }
  render() {
    return (
      <div className="gw-search__field gw-search__field-checkbox">
        <Checkbox.Group options={[{label: this.props.field.label, value: true}]} onChange={this.handleChange} value={this.props.value ? [true] : []}/>
      </div>
    )
  }
}

export default FieldCheckbox



// WEBPACK FOOTER //
// ./src/components/search/fields/Checkbox.js